import { Injectable } from "@angular/core";
import { EventLoggingParams, LogEventKey } from "src/app/interfaces/log";
import { FavourTournamentLogEvent } from "src/app/interfaces/log/favour-tournament-log";
import { LogService } from "../log.service";

@Injectable({
  providedIn: 'root'
})
export class FavourTournamentLogService {
  constructor(private logService: LogService) {
    
  }

  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, { ...params });
  }

  // [호불호 결과] 화면 진입
  logFwResultViewed(): void {
    this.eventLogging(FavourTournamentLogEvent.FW_RESULT_VIEWED, { category: 'fw_result' });
  }
  // [호불호 결과] 다음 버튼 클릭
  logFwResultNextButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_RESULT_NEXT_BUTTON_CLICKED, { category: 'fw_result', questionGroupTitle });
  }
  // [호불호 케미 온보딩] 화면 진입
  logFwChemiOnboardingViewed(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_ONBOARDING_VIEWED, { category: 'fw_chemi', purpose: 'onboarding', questionGroupTitle });
  }
  // [호불호 케미 온보딩] 결과 비교하기 버튼 클릭
  logFwChemiOnboardingCompareButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_ONBOARDING_COMPARE_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'onboarding', questionGroupTitle });
  }
  // [호불호 케미 온보딩] 타입스 홈으로 버튼 클릭
  logFwChemiOnboardingHomeButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_ONBOARDING_HOME_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'onboarding', questionGroupTitle });
  }
  // [호불호 케미 친구 선택] 화면 진입
  logFwChemiFriendSelectViewed(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_FRIEND_SELECT_VIEWED, { category: 'fw_chemi', purpose: 'select_friend', questionGroupTitle });
  }
  // [호불호 케미 친구 선택] 친구초대 버튼 클릭
  logFwChemiFriendSelectInviteButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_FRIEND_SELECT_INVITE_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'select_friend', questionGroupTitle });
  }
  // [호불호 케미 친구 선택 모달] 모달 open 
  logFwChemiFriendSelectModalImpression(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_FRIEND_SELECT_MODAL_IMPRESSION, { category: 'fw_chemi', purpose: 'select_friend_modal', questionGroupTitle });
  }
  // [호불호 케미 친구 선택 모달] 링크 복사 클릭 
  logFwChemiFriendSelectModalCopyButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_FRIEND_SELECT_MODAL_COPY_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'select_friend_modal', questionGroupTitle });
  }
  // [호불호 케미 친구 선택 모달] 카카오 전송 클릭 
  logFwChemiFriendSelectModalKakaoButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_FRIEND_SELECT_MODAL_KAKAO_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'select_friend_modal', questionGroupTitle });
  }
  // [호불호 케미 결과 - Empty] 화면 진입
  logFwChemiEmptyResultViewed(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_EMPTY_RESULT_VIEWED, { category: 'fw_chemi', purpose: 'result', questionGroupTitle });
  }
  // [호불호 케미 결과 - Empty] 링크 복사 클릭
  logFwChemiEmptyResultCopyButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_EMPTY_RESULT_COPY_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'result', questionGroupTitle });
  }
  // [호불호 케미 결과 - Empty] 카카오 전송 클릭
  logFwChemiEmptyResultKakaoButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_EMPTY_RESULT_KAKAO_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'result', questionGroupTitle });
  }
  // [호불호 케미 결과] 화면 진입
  logFwChemiResultViewed(questionGroupTitle?: string, score?: number): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_RESULT_VIEWED, { category: 'fw_chemi', purpose: 'result', questionGroupTitle, score });
  }
  // [호불호 케미 결과] 분석 카드 노출
  logFwChemiResultCardImpression(type: 'best' | 'worst' | 'diff', questionGroupTitle?: string, score?: number): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_RESULT_CARD_IMPRESSION, { category: 'fw_chemi', purpose: 'result', questionGroupTitle, score, type });
  }
  // [호불호 케미 결과] 다른 호불호 월드컵 하러 가기 버튼 클릭
  logFwChemiResultMoreFwQuizButtonClicked(questionGroupTitle?: string, score?: number): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_RESULT_MORE_FW_QUIZ_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'result', questionGroupTitle, score });
  }
  // (웹 only) [호불호 케미 결과] 앱 설치 버튼 클릭
  logFwChemiResultAppInstallClicked(questionGroupTitle?: string, score?: number): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_RESULT_APP_INSTALL_CLICKED, { category: 'fw_chemi', purpose: 'result', questionGroupTitle, score });
  }
  // (웹 only) [호불호 케미 친구 입장] 화면 진입
  logFwChemiJoinViewed(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_JOIN_VIEWED, { category: 'fw_chemi', purpose: 'join', questionGroupTitle });
  }
  // (웹 only) [호불호 케미 친구 입장] 친구랑 내 결과 비교하기 버튼 클릭
  logFwChemiJoinCompareButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_JOIN_COMPARE_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'join', questionGroupTitle });
  }
  // (웹 only) [호불호 케미 친구 입장] 로그인 모달 open
  logFwChemiJoinLoginModalImpression(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_JOIN_LOGIN_MODAL_IMPRESSION, { category: 'fw_chemi', purpose: 'join_modal', questionGroupTitle });
  }
  // (웹 only) [호불호 케미 친구 입장] 로그인 모달에서 버튼 클릭
  logFwChemiJoinLoginModalLoginButtonClicked(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_JOIN_LOGIN_MODAL_LOGIN_BUTTON_CLICKED, { category: 'fw_chemi', purpose: 'join_modal', questionGroupTitle });
  }
  // (웹 only) [호불호 케미 친구 입장 - 퀴즈] 질문지 화면 진입
  logFwChemiQuizQuestionnairViewed(questionGroupTitle?: string, stage?: number | string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_QUIZ_QUESTIONNAIR_VIEWED, { category: 'fw_chemi', purpose: 'quiz', questionGroupTitle, stage });
  }
  // (웹 only) [호불호 케미 친구 입장 - 퀴즈] submit
  logFwChemiQuizSubmit(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_QUIZ_SUBMIT, { category: 'fw_chemi', purpose: 'quiz', questionGroupTitle });
  }
  // (웹 only) [호불호 케미 친구 입장 - 분석중] 화면 진입
  logFwChemiStagingViewed(questionGroupTitle?: string): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_STAGING_VIEWED, { category: 'fw_chemi', purpose: 'staging', questionGroupTitle });
  }

  // [호불호 케미 리스트] 화면 진입
  logFwChemiListViewed(questionGroupTitle: string, isEmptyList: boolean): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_LIST_VIEWED, { questionGroupTitle, isEmptyList });

  }
  // [호불호 케미 리스트] 링크 복사 클릭
  logFwChemiListCopyButtonClicked(questionGroupTitle: string, isEmptyList: boolean): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_LIST_COPY_BUTTON_CLICKED, { questionGroupTitle, isEmptyList });

  }
  // [호불호 케미 리스트] 카카오 전송 클릭
  logFwChemiListKakaoButtonClicked(questionGroupTitle: string, isEmptyList: boolean): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_LIST_KAKAO_BUTTON_CLICKED, { questionGroupTitle, isEmptyList });

  }
  // [호불호 케미 리스트] 케미 클릭
  logFwChemiListChemiClicked(id: number, score: number, ranking: number): void {
    this.eventLogging(FavourTournamentLogEvent.FW_CHEMI_LIST_CHEMI_CLICKED, { id, score, ranking });

  }
}